import { isSpatiusProvider } from "@/hooks/spatius-primary-session-policy";
import type { AgentConnectionState } from "@/hooks/useLiveKitAgent";

type SessionUiStateArgs = {
  configuredAvatarProvider: string;
  connectionState: AgentConnectionState;
  hasSpatiusAvatarSession: boolean;
  isConnected: boolean;
  isRecording: boolean;
  selectedNoAvatar: boolean;
};

export function shouldBootstrapConnectingAvatar({
  configuredAvatarProvider,
  connectionState,
  isConnected,
  isRecording,
  selectedNoAvatar,
}: SessionUiStateArgs) {
  return (
    isRecording &&
    !selectedNoAvatar &&
    connectionState !== "failed" &&
    !isConnected &&
    !isSpatiusProvider(configuredAvatarProvider)
  );
}

export function shouldDisableSessionAvatar({
  configuredAvatarProvider,
  hasSpatiusAvatarSession,
  selectedNoAvatar,
}: Pick<
  SessionUiStateArgs,
  "configuredAvatarProvider" | "hasSpatiusAvatarSession" | "selectedNoAvatar"
>) {
  if (selectedNoAvatar) {
    return true;
  }

  return isSpatiusProvider(configuredAvatarProvider) && !hasSpatiusAvatarSession;
}

/**
 * The learner wants the avatar and Spatius is the provider, but the shared viewer
 * session is still being created: the avatar is on its way, not off. Layouts can
 * keep her place instead of switching when she arrives.
 */
export function isSessionAvatarStarting({
  configuredAvatarProvider,
  hasSpatiusAvatarSession,
  selectedNoAvatar,
}: Pick<
  SessionUiStateArgs,
  "configuredAvatarProvider" | "hasSpatiusAvatarSession" | "selectedNoAvatar"
>) {
  return (
    !selectedNoAvatar && isSpatiusProvider(configuredAvatarProvider) && !hasSpatiusAvatarSession
  );
}

export function shouldRenderTranscriptionSession({
  isConnected,
  isRecording,
}: Pick<SessionUiStateArgs, "isConnected" | "isRecording">) {
  return isConnected && isRecording;
}
